import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const FieldsReferencedByFieldQueryGql: DocumentNode = gql`
query FieldsReferencedByFieldQuery($fieldId: ID!, $first: Int!, $offset: Int!) {
  fields(filter: { id: $fieldId }) {
    ... on FieldReferencingField {
      fieldsConnection(first: $first, offset: $offset, orderBy: { field: ID, direction: ASC }) {
        totalCount
        nodes {
          id
          name
          datasource {
            name
            ... on PublishedDatasource {
              vizportalUrlId
            }
            ... on EmbeddedDatasource {
              id
              workbook {
                vizportalUrlId
              }
            }
          }
        }
      }
    }
  }
}
`;
